import { Typography } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
export const SectionTitle = _ref => {
  let {
    variant = 'paragraph1',
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Typography, {
    variant: variant,
    weight: "normal",
    children: children
  });
};
export const ColorsLabel = _ref2 => {
  let {
    children,
    skin = 'standard'
  } = _ref2;
  return /*#__PURE__*/_jsx(Typography, {
    variant: "paragraph2",
    skin: skin,
    children: children
  });
};